(function(){
  'use strict';

  angular.module('eclipseApp.core').controller('checkoutChangeInternetConfirmationCtrl', ['$scope', 'reviewSummary', '$state', 'orderConfirmation', 'accountDashboardManager', function($scope, reviewSummary, $state, orderConfirmation, accountDashboardManager){
    console.log('@checkoutChangeInternetConfirmationCtrl');

    var _self = {};
    _self.confirmationDetails = {};

    $scope.review = {};

    if (reviewSummary && orderConfirmation) {
      console.log('@checkoutChangeInternetConfirmationCtrl (orderConfirmation) ', orderConfirmation);

      _self.confirmationDetails = 
        (orderConfirmation && orderConfirmation.confirmChangeInternetPkg) ? 
          orderConfirmation.confirmChangeInternetPkg : {};

      $scope.order = orderConfirmation;
      angular.extend($scope.review, _self.confirmationDetails);
      $scope.reviewData = $scope.review; 

      $scope.review.tier = 
        (_self.confirmationDetails && _self.confirmationDetails.packageAdded) ?
          _self.confirmationDetails.packageAdded : {};

      accountDashboardManager.checkoutSession.confirmation.complete = true;
      accountDashboardManager.setSession('checkoutSession', accountDashboardManager.checkoutSession);
    } else {
      $state.go('myAccount.internet');
    }
  }]);
})();

